module.exports = __webpack_public_path__ + "static/media/heart-bg-red.afcbe829.svg";